module.exports = __webpack_public_path__ + "static/media/certificate-2015.5e19fcca.jpeg";